export default "__VITE_ASSET__BiyqAupG__"